// src/components/layout/Navbar.tsx

import React from 'react';
import { useAppSelector, useAppDispatch } from '../../hooks/redux';
import { logout } from '../../store/slices/authSlice';
import { useNavigate } from 'react-router-dom';

interface Props {
  collapsed: boolean;
  onMobileToggle: () => void;
}

export default function Navbar({ collapsed, onMobileToggle }: Props) {
  const user = useAppSelector((s) => s.auth.user);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const initials = user
    ? `${user.firstName?.[0] ?? ''}${user.lastName?.[0] ?? ''}`.toUpperCase()
    : 'A';

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <header className={`navbar-dashboard ${collapsed ? 'sidebar-collapsed' : ''}`}>
      {/* Hamburger — solo en móvil */}
      <button
        className="btn btn-link p-0 d-lg-none me-2"
        onClick={onMobileToggle}
        style={{ color: 'var(--fg-green)', fontSize: '1.4rem', lineHeight: 1 }}
        title="Abrir menú"
      >
        <i className="bi bi-list" />
      </button>

      {/* Título de la página */}
      <div className="navbar-brand">
        <i className="bi bi-shield-check" style={{ color: 'var(--fg-orange)' }} />
        <span>Panel Administrativo</span>
      </div>

      <div className="navbar-spacer" />

      {/* Badge notificaciones */}
      <div
        style={{ position: 'relative', cursor: 'pointer', padding: '6px 8px' }}
        title="Notificaciones"
      >
        <i className="bi bi-bell" style={{ fontSize: '1.2rem', color: 'var(--fg-muted)' }} />
      </div>

      {/* Usuario */}
      <div className="navbar-user dropdown">
        <div
          className="d-flex align-items-center gap-2"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          style={{ cursor: 'pointer' }}
        >
          <div className="avatar">{initials}</div>
          <div className="user-info d-none d-sm-block">
            <div className="user-name">
              {user?.firstName} {user?.lastName}
            </div>
            <div className="user-role">Administrador</div>
          </div>
          <i className="bi bi-chevron-down d-none d-sm-block" style={{ fontSize: '0.75rem', color: 'var(--fg-muted)' }} />
        </div>
        <ul className="dropdown-menu dropdown-menu-end shadow-sm" style={{ borderRadius: 10, minWidth: 180 }}>
          <li>
            <span className="dropdown-item-text" style={{ fontSize: '0.8rem', color: 'var(--fg-muted)' }}>
              {user?.email}
            </span>
          </li>
          <li><hr className="dropdown-divider" /></li>
          <li>
            <button className="dropdown-item text-danger d-flex align-items-center gap-2" onClick={handleLogout}>
              <i className="bi bi-box-arrow-right" />
              Cerrar sesión
            </button>
          </li>
        </ul>
      </div>
    </header>
  );
}
